import * as Yup from "yup";

const CicValidation = Yup.object({
  name: Yup.string().required("Name is required"),
  address: Yup.string().required("Address is required"),
  cooperativeId: Yup.string().required("Cooperative ID is required"),
  submissionNumber: Yup.string().required("Submission Number is required"),
  loanAmount: Yup.number()
    .required("Loan Amount is required")
    .positive("Loan Amount must be positive"),
  loanMaturityDate: Yup.date()
    .required("Loan Maturity Date is required")
    .nullable(),
  reportingBasis: Yup.string()
    .oneOf(
      ["DueIntrest", "DueInstallment", "LoanOverdue"],
      "Invalid Reporting Basis"
    )
    .required("Reporting Basis is required"),
  defaulterType: Yup.string().required("Defaulter Type is required"),
  citizenshipNumber: Yup.string().required("Citizenship Number is required"),
  citizenshipIssueDistrict: Yup.object().shape({
    label: Yup.string().required("Citizenship Issue District is required"),
    value: Yup.string().required("Citizenship Issue District is required"),
  }),
  fathersFullName: Yup.string().required("Father's Full Name is required"),
  grandfatherFullName: Yup.string().required(
    "Grandfather's Full Name is required"
  ),
  registrationNumber: Yup.string().required("Registration Number is required"),
});

export default CicValidation;
